export const POST_CODE_LIST = 'postCodeAddressList';
export const ADD_MANUALLY_SUFFIX = 'ManuallyClickedValue';
export const ADDRESS_LINE = 'address_line';
export const CITY_NAME = 'CityName';
export const POST_CODE = 'PostCode';
export const CITY_NAME_INT = 'CityNameInt';
export const COUNTRY_NAME_INT = 'CountryNameInt';
export const COUNTRY_NAME = 'CountryName';
export const COUNTY = 'county';
export const FLAT_NO = 'FlatNumber';
export const BUILDING_NO = 'BuildingNumber';
export const HOUSE_NAME = 'HouseName';
export const STREET_NAME = 'StreetName';
export const AREA_NAME = 'AreaName';
export const CHOOSE_ADD = 'Choose';
export const CHOOSE_ADD_YES = 'Yes';
export const CHOOSE_ADD_NO = 'No';
export const SELECT_ADDRESS_FIELD = 'SelectAddress';
export const MANUALLY_CLICKED = 'ManuallyClicked';
export const POSTCODE_ERROR = 'postcode_error';
export const POSTCODE_LIST_ERROR = 'emptyList';
export const COUNTRY_TYPE_ADDRESS = 'country_type_address';
